import { IconProps } from '../types';

/**
 * -----------------------------------------------------------------------------
 * Renders the LinkedIn icon.
 */
export function LinkedInIcon(props: IconProps) {
  return (
    <svg fill="none" viewBox="0 0 24 24" {...props}>
      <path
        d="
          M19.5 3.75H4.5C4.08579 3.75 3.75 4.08579 3.75 4.5V19.5C3.75 19.9142
          4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25
          19.5V4.5C20.25 4.08579 19.9142 3.75 19.5 3.75Z
        "
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M11.25 10.5V16.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8.25 10.5V16.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="
          M11.25 13.125C11.25 12.4288 11.5266 11.7611 12.0188 11.2688C12.5111
          10.7766 13.1788 10.5 13.875 10.5C14.5712 10.5 15.2389 10.7766 15.7312
          11.2688C16.2234 11.7611 16.5 12.4288 16.5 13.125V16.5
        "
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="
          M8.25 8.625C8.87132 8.625 9.375 8.12132 9.375 7.5C9.375 6.87868
          8.87132 6.375 8.25 6.375C7.62868 6.375 7.125 6.87868 7.125 7.5C7.125
          8.12132 7.62868 8.625 8.25 8.625Z
        "
      />
    </svg>
  );
}
